import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Tooltip, Link, ListItemText } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
// auth
import RoleBasedGuard from '../../../auth/RoleBasedGuard';
//
import Iconify from '../../iconify';
//
import { StyledItem, StyledIcon, StyledDotIcon } from './styles';
import { path, ROOTS_DASHBOARD } from 'src/routes/paths';
import { iconImage } from 'src/layouts/dashboard/nav/config-navigation';

// ----------------------------------------------------------------------

NavItem.propTypes = {
  open: PropTypes.bool,
  active: PropTypes.bool,
  item: PropTypes.object,
  depth: PropTypes.number,
  isExternalLink: PropTypes.bool,
};

export default function NavItem({ item, depth, open, active, isExternalLink, hasChild, ...other }) {
  const { translate } = useLocales();

  const { label, path: pathName, icon, info, children, disabled, caption, roles, parent } = item;

  const subItem = depth !== 1;

  const renderContent = (
    <StyledItem depth={depth} active={active} disabled={disabled} caption={!!caption} {...other}>
      {(icon) && <StyledIcon>{iconImage(icon)}</StyledIcon>}

      {/* {subItem && <StyledIcon><StyledDotIcon active={active && subItem} /></StyledIcon>} */}

      <ListItemText
        primary={`${translate(label)}`}
        secondary={
          caption && (
            <Tooltip title={`${translate(caption)}`} placement="top-start">
              <span>{`${translate(caption)}`}</span>
            </Tooltip>
          )
        }
        primaryTypographyProps={{
          noWrap: true,
          component: 'span',
          variant: active ? 'subtitle2' : 'body2',
        }}
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
        }}
        sx={{ ml: icon ? 0 : 5 }}
      />

      {info && (
        <Box component="span" sx={{ lineHeight: 0 }}>
          {info}
        </Box>
      )}

      {children.length > 0 && (
        <Iconify
          width={16}
          icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
          sx={{ ml: 1, flexShrink: 0 }}
        />
      )}
    </StyledItem>
  );

  const renderItem = () => {
    // Has child
    if (children.length > 0) {
      return renderContent;
    }
    // ExternalLink
    if (isExternalLink)
      return (
        <Link component={RouterLink} to={path(ROOTS_DASHBOARD, pathName)} underline="none">
          {renderContent}
        </Link>
      );




    // Default
    return (
      <Link component={RouterLink} to={path(ROOTS_DASHBOARD, pathName)} underline="none">
        {renderContent}
      </Link>
    );
  };

  return <RoleBasedGuard roles={roles}> {renderItem()} </RoleBasedGuard>;
}
